import React from "react";

// The verification widget of an IFRAME_POSTMESSAGE engine (Identomat, or the
// dummy engine of developers' machines; face runbook F4.2, the gateway's
// website prompt A2). Accepts only the widget's own `DONE` message, from the
// session's widgetOrigin - never a fixed origin; anything else is ignored.
// Camera and fullscreen are delegated to the frame; the page must be
// https:// or http://localhost for the camera to work.
//
// props: widgetUrl (carries the session's token: never log it), origin,
// title, onDone()
export default class IdentomatFrame extends React.Component {
  componentDidMount() {
    window.addEventListener("message", this.onMessage);
  }

  componentWillUnmount() {
    window.removeEventListener("message", this.onMessage);
  }

  onMessage = (e) => {
    if (!this.props.origin || e.origin !== this.props.origin) return;
    if (e.data === "DONE" && this.props.onDone) this.props.onDone();
  };

  render() {
    return (
      <iframe
        className="identomat-frame"
        src={this.props.widgetUrl}
        allow="camera; microphone; fullscreen"
        allowFullScreen
        title={this.props.title}
      />
    );
  }
}
